module.exports = __webpack_public_path__ + "img/hd1.d8baab5a.svg";